import * as Sentry from '@sentry/react';

import { getDashboardEnv } from '../config/env';

export function initSentry() {
  const env = getDashboardEnv();

  if (!env.sentryDsn) {
    return;
  }

  Sentry.init({
    dsn: env.sentryDsn,
    environment: env.appEnv,
    release: env.sentryRelease ?? undefined,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracesSampleRate: env.sentryTracesSampleRate,
    replaysSessionSampleRate: env.sentryReplaysSessionSampleRate,
    replaysOnErrorSampleRate: env.sentryReplaysErrorSampleRate,
    sendDefaultPii: false,
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
